import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { sanitizeClinicalHtml } from '../utils/clinicalHtml';

interface ClinicalHtmlFieldProps extends Omit<BoxProps, 'children' | 'dangerouslySetInnerHTML'> {
  html: string | null | undefined;
}

/** Exibe texto clínico que pode conter HTML limitado (<br>, <b>, …) após sanitização.
 *  Multilinha digitada como texto livre preserva quebras (HTML colapsaria \n sem pre-wrap).
 */
export default function ClinicalHtmlField({ html, sx, ...rest }: ClinicalHtmlFieldProps) {
  const safe = sanitizeClinicalHtml(html);
  if (!safe.trim()) return null;

  return (
    <Box
      component="div"
      {...rest}
      dangerouslySetInnerHTML={{ __html: safe }}
      sx={{
        typography: 'body2',
        whiteSpace: 'pre-wrap',
        '& p': { margin: 0 },
        '& ul, & ol': { marginTop: 0.5, marginBottom: 0.5, pl: 2.5 },
        wordBreak: 'break-word',
        ...sx,
      }}
    />
  );
}
